import { render, staticRenderFns } from "./LeaderboardBox.vue?vue&type=template&id=e29e3f48&scoped=true&"
import script from "./LeaderboardBox.vue?vue&type=script&lang=js&"
export * from "./LeaderboardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29e3f48",
  null
  
)

export default component.exports